module.exports = __webpack_public_path__ + "img/fena.38a0afdf.png";